import { h } from "vue";
import { createColumnHelper } from "@tanstack/vue-table";
import { OFFER_STATUS } from "@/utils/enum/offerStatus";
import Request from "@/services/request";
import ProductInfoCell from "@/components/DataTable/ProductInfoCell";
import store from "@/store";
import { sendViewProductDealsEvent } from "@/utils/ga4/helper";
import {
  PRODUCT_DEALS_MODIFY,
  PRODUCT_DEALS_APPLY,
  PRODUCT_DEALS,
  PRODUCT_DEAL_GOTO_PRODUCT_DETAIL,
  PRODUCT_DEAL_REJECT_OFFER,
} from "@/utils/enum/endpoints";
import SellerPriceOffer from "../partials/SellerPriceOffer";
import SalesOffer from "../partials/SalesOffer";
// Single request object for all requests in a scope
const request = new Request();

const columnHelper = createColumnHelper();

const handleProductDetail = async (pid) => {
  try {
    const response = await request.get(
      PRODUCT_DEAL_GOTO_PRODUCT_DETAIL.replace("{pid}", pid),
      {},
      null
    );
    const url = response.data.productUrl;
    url && window.open(url, "_blank");
  } catch {
    // console.error('Error fetching product details:', error);
  }
};

const generateProductInfoForHunt = (row) => {
  return {
    imageUrl: row.original.productImage,
    title: row.original.productName,
    productCode: row.original.productId,
    stockCode: row.original.sellerStockCode,
  };
};

const removeBlankAttributes = (obj) => {
  const result = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
      result[key] = obj[key];
    }
  });
  return result;
};

export const columns = [
  columnHelper.accessor("productName", {
    header: () => "Ürün Bilgisi",
    cell: ({ row }) => {
      const pid = row.original.productId;
      return h(ProductInfoCell, {
        productInfo: generateProductInfoForHunt(row),
        class: "hunt",
        isClickable: true,
        onClick: () => handleProductDetail(pid),
      });
    },
    size: 256,
  }),
  columnHelper.accessor("advantageousPrice", {
    header: "1. Teklif",
    cell: ({ row }) => {
      return h(SalesOffer, {
        dealStatus: row.original.dealStatus,
        upperPrice: row.original.advantageousOffer.upperPrice,
        lowerPrice: row.original.advantageousOffer.lowerPrice,
        offerPrice: row.original.advantageousOffer.offerPrice,
        commission: row.original.advantageousOffer.commission,
        offerStatus: row.original.advantageousOffer.offerStatus,
        startDate: row.original.advantageousOffer.offerAcceptedDate
          ? new Date(row.original.advantageousOffer.offerAcceptedDate)
          : null,
        endDate: row.original.advantageousOffer.offerRejectedDate
          ? new Date(row.original.advantageousOffer.offerRejectedDate)
          : null,
        plannedStartDate: new Date(row.original.startDate),
        plannedEndDate: new Date(row.original.finishDate),
        pid: row.original.productId,
        dealId: row.original.dealId,
        groupId: row.original.groupId,
        displayPrice: row.original.displayPrice,
        categoryId: row.original.categoryId,
        hasVariants: row.original.hasVariants,
      });
    },
    size: 273,
  }),
  columnHelper.accessor("superPrice", {
    header: "2. Teklif",
    cell: ({ row }) => {
      return h(SalesOffer, {
        dealStatus: row.original.dealStatus,
        upperPrice: row.original.superOffer.upperPrice,
        lowerPrice: row.original.superOffer.lowerPrice,
        offerPrice: row.original.superOffer.offerPrice,
        commission: row.original.superOffer.commission,
        offerStatus: row.original.superOffer.offerStatus,
        isRefused: row.original.superOffer.offerStatus === OFFER_STATUS.REFUSED,
        startDate: row.original.superOffer.offerAcceptedDate
          ? new Date(row.original.superOffer.offerAcceptedDate)
          : null,
        endDate: row.original.superOffer.offerRejectedDate
          ? new Date(row.original.superOffer.offerRejectedDate)
          : null,
        plannedStartDate: new Date(row.original.startDate),
        plannedEndDate: new Date(row.original.finishDate),
        pid: row.original.productId,
        dealId: row.original.dealId,
        groupId: row.original.groupId,
        displayPrice: row.original.displayPrice,
        categoryId: row.original.categoryId,
        hasVariants: row.original.hasVariants,
      });
    },
    size: 273,
  }),
  columnHelper.accessor("shockingPrice", {
    header: "3. Teklif",
    cell: ({ row }) => {
      return h(SalesOffer, {
        dealStatus: row.original.dealStatus,
        upperPrice: row.original.shockingOffer.upperPrice,
        lowerPrice: row.original.shockingOffer.lowerPrice,
        offerPrice: row.original.shockingOffer.offerPrice,
        commission: row.original.shockingOffer.commission,
        offerStatus: row.original.shockingOffer.offerStatus,
        isRefused:
          row.original.shockingOffer.offerStatus === OFFER_STATUS.REFUSED,
        startDate: row.original.shockingOffer.offerAcceptedDate
          ? new Date(row.original.shockingOffer.offerAcceptedDate)
          : null,
        endDate: row.original.shockingOffer.offerRejectedDate
          ? new Date(row.original.shockingOffer.offerRejectedDate)
          : null,
        plannedStartDate: new Date(row.original.startDate),
        plannedEndDate: new Date(row.original.finishDate),
        pid: row.original.productId,
        dealId: row.original.dealId,
        groupId: row.original.groupId,
        displayPrice: row.original.displayPrice,
        categoryId: row.original.categoryId,
        hasVariants: row.original.hasVariants,
      });
    },
    size: 273,
  }),
  columnHelper.accessor("sellerPriceOffer", {
    header: "Fiyat Teklifiniz",
    cell: ({ row }) => {
      return h(SellerPriceOffer, {
        commission: row.original.commissionRate,
        price: row.original.displayPrice,
        dealStatus: row.original.dealStatus,
        startDate: new Date(row.original.startDate),
        upperPrice: row.original.advantageousOffer.upperPrice,
        lowerPrice: row.original.shockingOffer.lowerPrice,
        dealId: row.original.dealId,
        groupId: row.original.groupId,
        categoryId: row.original.categoryId,
        productId: row.original.productId,
        commissionRates: commissionRates(row.original),
        hasVariants: row.original.hasVariants,
        index: row.index,
      });
    },
    size: 197,
  }),
];

export const getTableDataAsync = async (payload) => {
  const response = {
    data: null,
    error: null,
    pageCount: 0,
    periodList: [],
  };

  const sellerId = store.getters["auth/getSellerId"];
  const requestParams = removeBlankAttributes(payload);

  try {
    const result = await request.get(
      PRODUCT_DEALS.replace("{sellerId}", sellerId),
      requestParams
    );

    response.pageCount = result.data.pagingModel.pageCount;
    response.periodList = result.data.productDealOfferPeriodDtos;
    response.data = result.data.sellerProductDealDtos.map((productDealDto) => {
      const offerStatusList = [
        productDealDto.advantageousOffer.offerStatus,
        productDealDto.superOffer.offerStatus,
        productDealDto.shockingOffer.offerStatus,
      ];

      return {
        ...productDealDto,
        dealStatus: getDealStatus(offerStatusList),
      };
    });

    sendViewProductDealsEvent({
      deal_status: response.pageCount > 0 ? "available" : "unavailable",
      user_id: sellerId,
    });
  } catch (err) {
    response.error = err;
  }

  return { ...response };
};

const getDealStatus = (offerStatusList) => {
  const statusPriority = [
    OFFER_STATUS.REFUSED,
    OFFER_STATUS.SUPERSEDED,
    OFFER_STATUS.ACCEPTED,
    OFFER_STATUS.WAITING_FOR_APPLYING,
  ];

  return (
    statusPriority.find((status) => offerStatusList.includes(status)) ||
    OFFER_STATUS.WAITING_FOR_ACCEPTANCE
  );
};

export const modifyDeal = async ({
  dealId,
  groupId,
  price,
  categoryId,
  productId,
}) => {
  return await request.post(PRODUCT_DEALS_MODIFY.replace("{id}", dealId), {
    dealId: dealId,
    sellerId: store.getters["auth/getSellerId"],
    groupId: groupId,
    price: price,
    categoryId: categoryId,
    productId: productId,
  });
};

export const applyDeal = async ({
  dealId,
  groupId,
  price,
  categoryId,
  productId,
}) => {
  return await request.post(PRODUCT_DEALS_APPLY.replace("{id}", dealId), {
    dealId: dealId,
    sellerId: store.getters["auth/getSellerId"],
    groupId: groupId,
    price: price,
    categoryId: categoryId,
    productId: productId,
  });
};

export const commissionRates = (data) => {
  return {
    advantageousOffer: {
      upperPrice: data.advantageousOffer.upperPrice,
      lowerPrice: data.advantageousOffer.lowerPrice,
      commission: data.advantageousOffer.commission,
    },
    superOffer: {
      upperPrice: data.superOffer.upperPrice,
      lowerPrice: data.superOffer.lowerPrice,
      commission: data.superOffer.commission,
    },
    shockingOffer: {
      upperPrice: data.shockingOffer.upperPrice,
      lowerPrice: data.shockingOffer.lowerPrice,
      commission: data.shockingOffer.commission,
    },
  };
};

export const rejectOffer = async ({
  dealId,
  groupId,
  displayPrice,
  categoryId,
  productId,
}) => {
  return await request.post(PRODUCT_DEAL_REJECT_OFFER.replace("{id}", dealId), {
    dealId: dealId,
    sellerId: store.getters["auth/getSellerId"],
    groupId: groupId,
    price: displayPrice,
    categoryId: categoryId,
    productId: productId,
  });
};
